import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Client } from '../../models/clients.model';

type SelectedClient = string | { DBName?: string } | null;

@Injectable({
  providedIn: 'root',
})
export class ClientSelectionService {
  private selectedClientSubject = new BehaviorSubject<Client | null>(null);
  selectedClient$ = this.selectedClientSubject.asObservable();

  setSelectedClient(client: Client | null) {
    this.selectedClientSubject.next(client);
  }
  
  getSelectedClient(): SelectedClient {
    return this.selectedClientSubject.getValue();
  }
 
  getSelectedClientDbName(): string {
    const selectedClient = this.getSelectedClient();
 
    if (!selectedClient) {
      return '';
    }
 
    if (typeof selectedClient === 'string') {
      return selectedClient;
    }
 
    return selectedClient.DBName ?? '';
  }
}
